import { render } from "./projects.vue?vue&type=template&id=02c6f3fc"
import script from "./projects.vue?vue&type=script&lang=ts"
export * from "./projects.vue?vue&type=script&lang=ts"
script.render = render

export default script